const FEATURES = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '支持4K超清播放，自动适配网络带宽，画面细腻色彩饱满，享受影院级视觉体验。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '免广告纯净',
    desc: '全程无广告干扰，从播放到结束绝不弹出任何广告窗口，专注纯粹观影体验。',
  },
  {
    id: 3,
    icon: 'ri-flashlight-line',
    title: '极速加载',
    desc: '自研视频加速引擎，智能预加载技术让缓冲几乎无感，点击即播流畅到底。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '紧跟院线和平台更新节奏，最新资源第一时间上线，热门内容从不缺席。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              平台特色
            </h2>
            <p className="text-sm text-foreground-600">为什么选择51影院？四大核心优势</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {FEATURES.map((feature) => (
              <div
                key={feature.id}
                className="bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-300 transition-all duration-300"
              >
                <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 mb-4">
                  <i className={`${feature.icon} text-xl text-primary-500`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}